import getColors from '@data-fair/components-app/colors/colors'

export default function colors (colors, minValue, maxValue, quantiles) {
  if (colors.type === 'enum') {
    if (colors.enumOptions.scheme.type === 'manual') return colors.enumOptions.valuesColor
    else {
      const dict = getColors(colors.enumOptions.scheme, colors.enumOptions.valuesColor.map((v, i) => i))
      return colors.enumOptions.valuesColor.map((v, i) => ({ color: dict[i], value: v.value }))
    }
  } else if (colors.type === 'range') {
    if (colors.rangeOptions.scheme.type === 'manual') {
      return colors.rangeOptions.rangesColor.map(r => ({
        ...r,
        value: r.min.toLocaleString('fr') + ' - ' + r.max.toLocaleString('fr')
      }))
    } else {
      var start = minValue
      var ranges = []
      if (minValue === maxValue) {
        ranges.push({
          min: start,
          max: start
        })
      } else {
        if (colors.rangeOptions.ranges.type === 'manual') {
          ranges = colors.rangeOptions.ranges.ranges
        } else if (colors.rangeOptions.ranges.type === 'equals') {
          const incr = (maxValue - minValue) / colors.rangeOptions.ranges.size
          while (start < maxValue && ranges.length < colors.rangeOptions.ranges.size) {
            ranges.push({
              min: start,
              max: start + incr
            })
            start += incr
          }
          ranges[ranges.length - 1].max = maxValue + 1e-12
        } else {
          ranges = quantiles
        }
      }
      const dict = getColors(colors.rangeOptions.scheme, (ranges || []).map((v, i) => i))
      return (ranges || []).map((v, i) => {
        const maximumFractionDigits = v.min === v.max ? 10 : Math.max(4 - Math.ceil(Math.log10(v.max - v.min)), 0)
        return { ...v, color: dict[i], value: v.min.toLocaleString('fr', { maximumFractionDigits }) + ' - ' + v.max.toLocaleString('fr', { maximumFractionDigits }) }
      })
    }
  }
}
